import { useEffect, useState, useCallback } from "react";
import { getDomains } from "../services/masterDataService";

export const useDomains = () => {
  const [domains, setDomains] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDomains = useCallback(async () => {
    setLoading(true);
    setError(null);
    const UserId = sessionStorage?.getItem("userId") || "";

    try {
      const data = await getDomains(UserId);  
      setDomains(data || []);
    } catch (err) {
      console.error("Failed to load domains:", err);
      setError(err.message || "Failed to load domains");
      setDomains([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDomains();
  }, [fetchDomains]);

  return { 
    domains, 
    loading, 
    error,
    refetch: fetchDomains   
  };
};